import React from "react";
import { Formik, Field } from "formik";
import { Button, Form } from "react-bootstrap";
import {
  FieldInput,
  FieldButtonGroup,
  FieldTextarea,
} from "../../../components";
import { setManageMasterToastInfo } from "../../../contexts";
import { returnOnlyIfBoolean, toOptionValuesFromMapper } from "../../../utils";
import { isEmpty, get } from "lodash";
import { UpsertAdvisorRepresentative } from "../../../services";

export const AdvisorRepresentativeCreateEditSlider = (props) => {
  const { setEdit, data, create, advisorId, dispatch } = props;
  const initialValues = {};

  const onFormSubmit = (values, { setFieldError, setFieldTouched }) => {
    // console.log(values,data,clearingPartnerId,"Values")

    const payload = {
      id: get(values, "id", 0),
      name: get(values, "name", ""),
      advisorId: advisorId,
      number: get(values, "number", ""),
      branchId: get(values, "branchId", ""),
      contact: {
        email: get(values, "contact.email", ""),
        mobilePhoneNumber: get(values, "contact.mobilePhoneNumber", ""),
      },
    };
    console.log(payload);
    UpsertAdvisorRepresentative(payload)
      .then((response) => {
        if (response.isSuccessful) {
          setEdit();
          dispatch(
            setManageMasterToastInfo({
              showToast: true,
              toastMessage: "Data saved successfully",
            })
          );
        } else {
          for (var i = 0; i < response.errorMessages?.length; i++) {
            var _ = response.errorMessages[i];
            setFieldTouched(_.controlName, true);
            setFieldError(_.controlName, `${_.errorCode} : ${_.message}`);
          }
        }
      })
      .catch((err) => {});
  };

  return (
    <Formik
      initialValues={!isEmpty(data) ? data : initialValues}
      onSubmit={onFormSubmit}
      enableReinitialize
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({
        handleChange,
        setFieldValue,
        handleSubmit,
        setValues,
        values,
        setSubmitting,
        ...rest
      }) => {
        console.log(advisorId, values, "Values");
        return (
          <Form
            autoComplete="off"
            className="h-100"
            onSubmit={handleSubmit}
            validated={!isEmpty(rest.errors)}
          >
            <div className="inside-content">
              <div className="d-flex justify-content-between align-baseline clearing-partner-edit-slider">
                <div>
                  <p className="investment-heading">
                    {create ? "Create" : "Edit"} Advisor Representative
                  </p>
                </div>
                <div>
                  <Button variant="secondary" onClick={setEdit}>
                    Cancel
                  </Button>
                  <Button variant="primary" type="submit" className="ml-4">
                    Save
                  </Button>
                </div>
              </div>

              <Field
                size="md"
                isRequired
                name={"name"}
                label={"Advisor Representative Name"}
                type="text"
                autoComplete="off"
                value={values["name"]}
                onChange={handleChange}
                //   disabled={isAddedToMaster || (isEdit && !isSave)}
                component={FieldInput}
              />
              <Field
                size="md"
                isRequired
                name={"number"}
                label={"Advisor Representative Number"}
                type="text"
                autoComplete="off"
                value={values["number"]}
                onChange={handleChange}
                //   disabled={isAddedToMaster || (isEdit && !isSave)}
                component={FieldInput}
              />
              <Field
                size="md"
                isRequired
                name={"branchId"}
                label={"Branch ID"}
                type="text"
                autoComplete="off"
                value={values["branchId"]}
                onChange={handleChange}
                //   disabled={isAddedToMaster || (isEdit && !isSave)}
                component={FieldInput}
              />
              <Field
                size="md"
                name={"contact.email"}
                label={"Email"}
                type="text"
                autoComplete="off"
                value={values["contact.email"]}
                onChange={handleChange}
                //   disabled={isAddedToMaster || (isEdit && !isSave)}
                component={FieldInput}
              />
              <Field
                size="md"
                name={"contact.mobilePhoneNumber"}
                label={"Phone Number"}
                type="text"
                autoComplete="off"
                value={values["contact.mobilePhoneNumber"]}
                onChange={handleChange}
                //   disabled={isAddedToMaster || (isEdit && !isSave)}
                component={FieldInput}
              />
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};
